import classNames from 'classnames';
import type { FC } from 'react';
import { t } from 'src/lib/player/i18n';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import MultiSelect from './MultiSelect';

interface Props {
  availableTags: Map<string, Array<[string, number]>>;
  itemStyle: React.CSSProperties;
  selectedTags: Map<string, Array<string>>;
  onReset: () => void;
  onToggleTag: (tagKey: string, value: string) => void;
}

export const ParticipantsFilter: FC<Props> = ({
  availableTags,
  itemStyle,
  selectedTags,
  onReset,
  onToggleTag,
}) => {
  return (
    <div key="starter-filter-row" className="starter-list-filter" style={itemStyle}>
      {Array.from(availableTags.keys(), (tagKey) => (
        <div key={`tag-select-${tagKey}`}>
          <MultiSelect
            tagKey={tagKey}
            values={availableTags.get(tagKey) || []}
            selectedValues={selectedTags.get(tagKey)}
            onToggle={onToggleTag}
          />
        </div>
      ))}
      <div key="deselect-tag-button">
        <div
          className={classNames('starter-list-button', {
            'starter-list-button-disabled': selectedTags.size === 0,
          })}
          {...onClickGenerator(() => {
            onReset();
          })}
        >
          {t('list.DESELECT_TAG')}
        </div>
      </div>
    </div>
  );
};
